export default __webpack_public_path__ + "static/save-a-funnel-dark-mode-da4477214962b9953adc45ddc5c65203.mp4";